import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

export const useUnlinkItemsTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    ...trpc.frontend.linkedItem.unlink.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.linkedItem.linkedItems.queryKey(),
        });
        // COI-471 parity: Apollo twin also evicts every linkable entity family
        // (unlinking changes each side's linked-items tab / counts / scores).
        await Promise.all([
          queryClient.invalidateQueries({
            queryKey: trpc.frontend.acceptance.pathKey(),
          }),
          queryClient.invalidateQueries({
            queryKey: trpc.frontend.action.pathKey(),
          }),
          queryClient.invalidateQueries({
            queryKey: trpc.frontend.appetite.pathKey(),
          }),
          queryClient.invalidateQueries({
            queryKey: trpc.frontend.control.pathKey(),
          }),
          queryClient.invalidateQueries({
            queryKey: trpc.frontend.controlGroup.pathKey(),
          }),
          queryClient.invalidateQueries({
            queryKey: trpc.frontend.document.pathKey(),
          }),
          queryClient.invalidateQueries({
            queryKey: trpc.frontend.indicator.pathKey(),
          }),
          queryClient.invalidateQueries({
            queryKey: trpc.frontend.issue.pathKey(),
          }),
          queryClient.invalidateQueries({
            queryKey: trpc.frontend.obligation.pathKey(),
          }),
          queryClient.invalidateQueries({
            queryKey: trpc.frontend.obligationChange.pathKey(),
          }),
          queryClient.invalidateQueries({
            queryKey: trpc.frontend.risk.pathKey(),
          }),
        ]);
      },
    }),
  });

  const unlinkItems = async (ids: string[]) => {
    await mutation.mutateAsync({ Ids: ids });
  };

  return {
    unlinkItems,
    loading: mutation.isPending,
    error: mutation.error,
  };
};
